import * as React from 'react';
import {Helmet} from 'react-helmet';

import {TitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {PageName} from '@spaced-out/ui-design-system/lib/components/PageTitle';

import useI18n from 'src/hooks/useI18n';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {usePageTitle} from 'src/contexts/page-title-context';
import {duotoneIconStyle} from 'src/utils/app-shell';
import AskAiTypeahead from 'src/components/dashboard/askai-typeahead';
import AiTeamSection from 'src/components/dashboard/ai-team-section';
import AnalyticsSection from 'src/components/dashboard/analytics-section/analytics-section';

import css from './dashboard-v2.css';

// ponytail: home renovation v2; gated by the enable_homepage agency config in src/reroutes/app.tsx.
// Chips + Your Metrics sections land in follow-up changes.
function DashboardV2(): React.ReactElement {
  const {t} = useLabelTranslation();
  const {labelI18nInstance} = useI18n();
  const language = labelI18nInstance.language;
  const {
    actions: {setPageTitleProps},
  } = usePageTitle();

  // Same app-shell header as the legacy dashboard (title + house icon).
  React.useEffect(() => {
    setPageTitleProps({
      customPageNameComponent: (
        <PageName>
          <TitleMedium>{t('Dashboard', 'Dashboard')}</TitleMedium>
          <Icon type="duotone" name="house" style={duotoneIconStyle} />
        </PageName>
      ),
      showBackButton: false,
    });
  }, [language]);

  return (
    <div className={css.dashboard} data-qa-id="dashboard-v2">
      {/* @ts-expect-error - TS2786 - 'Helmet' cannot be used as a JSX component. */}
      <Helmet title={t('Dashboard', 'Dashboard')} />
      <AskAiTypeahead />
      <AiTeamSection />
      <AnalyticsSection />
    </div>
  );
}

export default DashboardV2;
